import { getConditionCategories } from './categoryUtils'

export function useFilterPanel(filters, visits, allDiseaseCategories, trackMap) {

  const DATE_LABEL_KEYS = {
    today: 'ppv.date_range.today',
    week: 'ppv.date_range.this_week',
    month: 'ppv.date_range.this_month',
    lastMonth: 'ppv.date_range.last_month',
    specific: 'ppv.date_range_modal.title',
    older: 'ppv.older_visits.title',
  }

  const TRIAGE_LABEL_KEYS = {
    immediate: 'ppv.triage.immediate',
    urgent: 'ppv.triage.urgent',
  }

  function activeFilterCount() {
    const { tracks, diseaseCategories, dateRange, triages, conditionMode } = filters.value

    let count = 0

    if (tracks?.length) {
      count++
    }

    if (diseaseCategories?.length) {
      count++
    }
    
    if (triages?.length) {
      count++
    }

    if (dateRange !== 'month') {
      count++
    }

    if (conditionMode === 'all') {
      count++
    }

    return count
  }

  function activeDateLabel() {
    return DATE_LABEL_KEYS[filters.value.dateRange] || DATE_LABEL_KEYS.month
  }

  function buildDiseaseCounts() {
    const counts = {}

    visits.value.forEach((visit) => {
      if (!visit.conditions) {
        return
      }

      visit.conditions.forEach((condition) => {
        getConditionCategories(condition).forEach((category) => {
          if (!counts[category]) {
            counts[category] = 0
          }

          counts[category]++
        })
      })
    })

    return counts
  }

  function activeDiseaseCategories() {
    const counts = buildDiseaseCounts()

    return Object.entries(counts).map(([name, count]) => {
      return { name, count }
    })
  }

  function inactiveDiseaseCategories() {
    const counts = buildDiseaseCounts()
    const activeNames = new Set(Object.keys(counts))

    return allDiseaseCategories.value
      .filter((name) => {
        return !activeNames.has(name)
      })
      .map((name) => {
        return { name, count: 0 }
      })
  }

  function getTrackLabel(val) {
    if (!trackMap.value) {
      return val
    }

    if (!trackMap.value[val]) {
      return val
    }

    return trackMap.value[val]
  }

  function getTriageLabel(val) {
    return TRIAGE_LABEL_KEYS[val] || val
  }

  return {
    activeFilterCount,
    activeDateLabel,
    activeDiseaseCategories,
    inactiveDiseaseCategories,
    getTrackLabel,
    getTriageLabel
  }
}
